import { Stack } from "@mui/material";
import { Alert, Button, Typography } from "@platform/design-system";

import InputDate from "../../../../components/inputDate";

type OtherActionsProps = {
  additionalContent: React.ReactNode;
  onClickClear: () => void;
  coverageCount: number;
  effectiveDate: Date | null;
  onEffectiveDateChange: (date: Date | null) => void;
};

export const OtherActions: React.FC<OtherActionsProps> = ({
  additionalContent,
  onClickClear,
  coverageCount,
  effectiveDate,
  onEffectiveDateChange,
}) => (
  <Stack direction="column" spacing={2}>
    <Stack
      direction="row"
      justifyContent="space-between"
      spacing={2}
      alignItems="center"
    >
      <Typography variant="body-large">
        {coverageCount} Coverage(s) Selected
      </Typography>
      <Button
        variant="tertiary"
        disabled={coverageCount === 0}
        onClick={() => onClickClear()}
        sx={{
          "&.Mui-disabled": {
            color: "text.disabled",
            opacity: 1,
          },
        }}
      >
        Clear
      </Button>
    </Stack>

    {additionalContent}

    <Alert severity="info" title="Notice">
      If multiple coverages are selected, the entered Effective Date will apply
      to all records.
    </Alert>

    <InputDate
      label="Effective Date"
      value={effectiveDate}
      onChange={(date) => onEffectiveDateChange(date)}
    />
  </Stack>
);
